import { render, staticRenderFns } from "./addPaper.vue?vue&type=template&id=5c83b88a&scoped=true"
import script from "./addPaper.vue?vue&type=script&lang=js"
export * from "./addPaper.vue?vue&type=script&lang=js"
import style0 from "./addPaper.vue?vue&type=style&index=0&id=5c83b88a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c83b88a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c83b88a')) {
      api.createRecord('5c83b88a', component.options)
    } else {
      api.reload('5c83b88a', component.options)
    }
    module.hot.accept("./addPaper.vue?vue&type=template&id=5c83b88a&scoped=true", function () {
      api.rerender('5c83b88a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/exam-manage/addPaper.vue"
export default component.exports